module.exports = __webpack_public_path__ + "static/img/code.2f6bce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.png
// module id = Cwdn
// module chunks = 0